import { CreateFulfillmentOrderPaymentIntentState } from './createFulfillmentOrderPaymentIntent.types'

const createFulfillmentOrderPaymentIntentInitialState: CreateFulfillmentOrderPaymentIntentState = {
  loading: false,
  error: null,
  success: null
}

export default createFulfillmentOrderPaymentIntentInitialState
